<div class="p-3 bg-green color-white">
	<p class="small uc text-center mb-0">Création d'un compte<br/>Mares Libellules</p>
</div>

<form novalidate>
	<?-user.getFormError()?>

	<? var offline = !app.is('online'); ?>

	<div class="p-3 bb">
		<p class="fw-600 color-green">Informations de connexion</p>
		<? if( offline ) { ?>
			<div class="alert alert-warning">
				La création d'un compte est impossible sans accès à Internet.
			</div>
		<? } ?>
		<div class="form-group">
			<?-user.getFormField('email','Adresse email', offline ? {type:'email', disabled:true} : {type:'email'},{class:'fw-600 is-required'})?>
			<small class="form-text text-muted">Votre adresse email sera votre identifiant de connexion</small>
		</div>
		<div class="form-group">
			<?-user.getFormField('password','Mot de passe', offline ? {type:'password', disabled:true} : {type:'password'},{class:'fw-600 is-required'})?>
		</div>
		<div class="form-group">
			<?-user.getFormField('confirm','Confirmez le mot de passe', offline ? {type:'password', disabled:true} : {type:'password'},{class:'fw-600 is-required'})?>
		</div>
	</div>

	<div class="p-3 bb">
		<p class="fw-600 color-green">Informations de contact</p>
		<div class="form-group pb-2">
			<?-user.getFormField('lastname','Nom de famille', offline ? {disabled:true} : {},{class:'fw-600'})?>
		</div>
		<div class="form-group pb-2">
			<?-user.getFormField('firstname','Prénom', offline ? {disabled:true} : {},{class:'fw-600'})?>
		</div>
		<div class="form-group pb-2">
			<?-user.getFormField('name','Nom public / Pseudo', offline ? {disabled:true} : {},{class:'fw-600'})?>
		</div>
		<div class="form-group pb-2">
			<?-user.getFormField('address','Adresse', offline ? {type:'textarea',rows:3, disabled:true} : {type:'textarea',rows:3},{class:'fw-600'})?>
		</div>
		<div class="form-group pb-2">
			<?-user.getFormField('zip','Code postal', offline ? {disabled:true} : {},{class:'fw-600 is-required'})?>
		</div>
		<div class="form-group pb-2">
			<?-user.getFormField('city','Ville', offline ? {disabled:true} : {},{class:'fw-600'})?>
		</div>
		<div class="form-group pb-2">
			<?-user.getFormField('phone','Téléphone', offline ? {disabled:true} : {},{class:'fw-600'})?>
		</div>
		<div class="form-group pb-2">
			<?-user.getFormField('company','Structure', offline ? {disabled:true} : {},{class:'fw-600'})?>
		</div>
		<div class="form-group pb-2">
			<div class="custom-control custom-checkbox">
				<?-user.getFieldInput('config_animation', offline ? {type:'boolean', disabled:true} : {type:'boolean'})?>
				<?-user.getFieldLabel('config_animation',"J'accepte d'être sollicité.e dans le cadre de l'animation du programme <q>Mares où êtes-vous ?</q>",{class:'custom-control-label'})?>
			</div>
		</div>
		<div class="form-group">
			<div class="custom-control custom-checkbox">
				<?-user.getFieldInput('config_complement', offline ? {type:'boolean', disabled:true} : {type:'boolean'})?>
				<?-user.getFieldLabel('config_complement',"Je souhaite recevoir des informations complémentaires de la part des partenaires du projet",{class:'custom-control-label'})?>
			</div>
		</div>
	</div>

	<div class="p-3 bb">
		<button type="submit" class="btn btn-lg btn-green btn-block"<?= offline ? ' disabled' : '' ?>>Créer le compte</button>
	</div>

	<div class="p-3 bb">
		<p class="text-center small text-secondary mb-0">
			<?-data.get('text_contact')?>
		</p>
	</div>
	<div class="p-3">
		<p class="text-center small text-secondary mb-0">
			<?-data.get('text_cnil')?>
		</p>
	</div>
</form>
